import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function noticeOf(state: unknown): string | null {
  return typeof state === "object" && state !== null && "notice" in state && typeof state.notice === "string"
    ? state.notice
    : null;
}

/**
 * One sentence that arrives with a navigation (UX rulings 10/11, F-8):
 * „Du hast „…“ von … übernommen." on the record after „Annehmen", „… hat
 * „…“ übernommen — …" on the register after a withdrawal came too late.
 * Read once into state — the screen shows it while it stands — and taken
 * out of the history entry, so a reload or „Zurück" does not say it again.
 */
export function useRouteNotice(): string | null {
  const location = useLocation();
  const navigate = useNavigate();
  const carried = noticeOf(location.state);
  const [notice] = useState(carried);
  useEffect(() => {
    if (carried === null) return;
    navigate(`${location.pathname}${location.search}${location.hash}`, { replace: true, state: null });
  }, [carried, navigate, location.pathname, location.search, location.hash]);
  return notice;
}
